<template>
	<div>
		<Modal v-model="modal.ifShow" :title="modal.Title" width="78%" :mask-closable="false" :closable="false">
			<!--控件添加修改-->

	<Row>
        <Col span="12">
		
		<div class="battery-info-container">
  
    <div class="basic-info">
      <div class="info-row">
        <span>设备编码：{{ deviceInfo.EquipNo }}</span>
        <span>SIM卡的IMSI信息：{{ deviceInfo.SimImsi }}</span>
      </div>
      <div class="info-row">
        <span>SIM卡的iccid信息：{{ deviceInfo.SimIccid }}</span>
        <span>软件版本：{{ deviceInfo.SoftVersion }}</span>
      </div>
      <div class="info-row">
        <span>协议版本：{{ deviceInfo.ProtocolVersion }}</span>
        <span>硬件版本：{{ deviceInfo.HardVersion }}</span>
      </div>
      <div class="info-row">
        <span>上报时间：{{ deviceInfo.ReportTime }}</span>
      </div>
    </div>
    
    <div class="data-table">
      <table>
        <tr>
          <td>经度</td>
          <td>{{ batteryData.Longitude }}</td>
          <td>电池状态</td>
          <td colspan="3">{{ batteryData.BatteryWorkStatusDesc }}</td>
        </tr>
        <tr>
          <td>纬度</td>
          <td>{{ batteryData.Latitude }}</td>
          <td>总电压</td>
          <td colspan="3">{{ batteryData.TotalVoltage }} V</td>
        </tr>
        <tr>
          <td>GSI信号强度</td>
          <td>{{ batteryData.GsmRssi }}</td>
          <td>总电流</td>
          <td colspan="3">{{ batteryData.TotalCurrent }} A</td>
        </tr>
        <tr>
          <td>循环次数</td>
          <td>{{ batteryData.LoopNum }}</td>
          <td>SOC</td>
          <td colspan="3">{{ batteryData.SOC }} %</td>
        </tr>
        <tr>
          <td>剩余容量</td>
          <td>{{ batteryData.RemainCapacity }} AH</td>
          <td>SOH</td>
          <td colspan="3">{{ batteryData.SOH }} %</td>
        </tr>
        <tr>
          <td>本次充电电量</td>
          <td> KWH</td>
          <td>单体最高电压位置</td>
          <td>{{ batteryData.CellHiVoltagePos }}</td>
		  <td>从控</td>
		  <td></td>
        </tr>
        <tr>
          <td>累计充电电量</td>
          <td>{{ batteryData.SumChargeCapacity }} KWH</td>
          <td>单体最高电压</td>
          <td colspan="3">{{ batteryData.CellHiVoltage }} mv</td>
        </tr>
        <tr>
          <td>本次放电电量</td>
          <td> KWH</td>
          <td>单体最低电压位置</td>
          <td>{{ batteryData.CellLoVoltagePos }}</td>
		  <td>从控</td>
		  <td></td>
         
        </tr>
        <tr>
          <td>累计放电电量</td>
          <td>{{ batteryData.SumDischargeCapacity }} KWH</td>
          <td>单体最低电压</td>
          <td colspan="3">{{ batteryData.CellLoVoltage }}  mv</td>
        </tr>

        <tr>
          <td>报警级别</td>
          <td>{{ batteryData.AlarmLevel }}</td>
          <td>单体最高温度位置</td>
          <td>{{ batteryData.CellHiTempPos }}</td>
		  <td>从控</td>
		  <td></td>
        </tr>
		 <tr>
          <td>从控个数</td>
          <td>{{ batteryData.Slave }}</td>
          <td>单体最高温度</td>
          <td colspan="3">{{ batteryData.CellHiTemp }} °C</td>
        </tr>

        <tr>
          <td>压差</td>
          <td>{{ batteryData.BalancedActivateVoltDiff }} mv</td>
          <td>单体最低温度位置</td>
          <td>{{ batteryData.CellLoTempPos }} </td>
		  <td>从控</td>
		  <td></td>
        </tr>
		 <tr>
          <td>主控温度</td>
          <td>{{ batteryData.McbTemperature1 }} °C</td>
          <td>单体最低温度</td>
          <td colspan="3">{{ batteryData.CellLoTemp }} °C</td>
		 
        </tr>

      </table>
    </div>
    
    <div class="gps-history">
      <h3>GPS历史轨迹</h3>
      <div class="history-list">
        <div class="history-item" v-for="(item, index) in gpsHistory" :key="index">
          <span class="index">{{ index + 1 }}</span>
          <span class="time">{{ item.ReportTime }}</span>
          <span class="location">
			<span>E {{ item.Longitude }}</span>
			<span style="margin-left:20px;">N {{ item.Latitude }}</span>
		</span>
        </div>
      </div>
    </div>
    
    <!-- <div class="device-location">
      <h3>设备位置</h3>
      <p>业有限公司</p>
      <p>苏州特约包装有限公司</p>
      <p>苏州诺美尔</p>
      <p>经营电话：02040576,31 012314</p>
      <p>QQ邮箱：0205-03-20 12 01 56</p>
    </div> -->
  </div>

		</Col>
        <Col span="12">
		
		<div id="map" style="width: 95%;height: 98%;margin-top: 5px;margin-left:5%; ">
		</div>

		</Col>
    </Row>




				

		
	<div v-if="modal.type=='detail'" slot="footer">
				<Button type="warning" size="large" @click="modalOk('cancle')">{{ $t('Common.Cancel') }}</Button>
				<Button type="success" size="large" @click="modalOk('detail')">{{ $t('Common.Confirm') }}</Button>
			</div>
		
		</Modal>
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import dateFormat from '../../../../../public/js/comm.js'
	import webapi from '../../../../webapi.js';
	import MapObj from '@/js/TMap.js';

	export default {
		data() {
			
			return {

				
				mapInst: null,
				mapLng: 0,
				mapLat: 0,
				zindex: 2000,
				modal: {
					Title: "轨迹",
					type: "location"
				},
						//地图modal
				center: [114.198595, 22.633595],

				modal: {
					Title: "电池信息",
					type: "detail",
					ifShow: false,
					canInput: false
				},
				
				modalInfo: {
					"Id": 0,
					"Type": 0,
					"Name": "",
					"Content": "",
					"Status": 0,
					"StartTime": new Date(),
					"EndTime": new Date(),
				},
				zindex: 2000,
				upHeader: {
					'Authorization': "Bearer " + encodeURIComponent(localStorage.AccessToken)
				},
				imgName: '',
				visible: false,
				/****************/
				// Validate Fields
				ruleInline: {
					// Name: [{
					// 	validator: validateOpId,
					// 	trigger: 'blur',
					// }],
					RoleName: [{
						required: true,
						message: '控件名称',
						trigger: 'blur'
					}],
					RoleDesc: [{
						required: true,
						message: '显示名称',
						trigger: 'blur'
					}],
				},

	 deviceInfo: {
        
      },
      batteryData: {
       BatteryWorkStatusDesc:''
      },
      gpsHistory: [
      
      ]

			};
		},
		methods: {


           //地图modal
			mapOpen: function(Longitude,Latitude) {
				
				console.log("location2:",Longitude,Latitude);
				const _this = this;
	
				let latlng = [Longitude, Latitude];
				this.mapLng = Longitude;
				this.mapLat = Latitude;

                _this.mapInst = new MapObj(window.TMap);
				_this.mapInst.initMap('map', 10, latlng[0], latlng[1]);
				const markerId = 1;
				_this.mapInst.createMarker(markerId, latlng[0], latlng[1]);

			},


			GetBatteryDetail(EquipNo){
             console.log("GetBatteryDetail,EquipNo=",EquipNo);   
             this.$axios.post(webapi.base_api_url + "/Operations/GetBatteryDetail", {
				EquipNo:EquipNo
			 }).then(res => {
			
			  var data =res.data.Data;
			  this.deviceInfo=data.DeviceInfo;
			  this.batteryData =data.McData;
			  this.batteryData.BatteryWorkStatusDesc =data.BatteryWorkStatusDesc;
			  console.log(this.batteryData);  
			  this.gpsHistory =data.His;

			  this.mapOpen(this.batteryData.Longitude, this.batteryData.Latitude);
              //this.DeviceList =res.data.Data.List;
              console.log("GetBatteryDetail,resp2,",res.data.Data);  
			 })
            },

			
			show: function(type, params) {
				const _this = this;
				if (type == "detail") {
					_this.modal.Title = "电池信息";
					_this.modal.type = "detail";
					console.log("detail:",params)

					_this.GetBatteryDetail(params.EquipNo);
				} 
				_this.modal.ifShow = true
			},
			
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case 'cancle':
						_this.mapInst.destroyMap();
						_this.modal.ifShow = false
						break;
					case 'detail':
				
				        _this.mapInst.destroyMap();
						_this.modal.ifShow = false
						break;
			
					default:
						break;
				}
			},
		
			/**********Component Method*********/
			handleView(name) {
				this.imgName = name;
				this.visible = true;
			},
			handleRemove(file) {
				console.log(file)
				const _this = this
				if (_this.PictureDelCache.indexOf(file.name) > 0) {
					console.log('Delete cache ')
				} else {
					console.log('Cache is not exist')
					_this.PictureUpCache.push(file.name)
				}
				const fileList = _this.$refs.upload.fileList;
				_this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
				_this.$nextTick(() => {
					
					_this.uploadList = _this.$refs.upload.fileList
					_this.defaultList = _this.$refs.upload.fileList
				})
				_this.StationPicturesArray = _this.StationPicturesArray.filter(function(item, index,
					arr) {
					console.log(file.name)
					return item != file.name
				})
			},
			handleSuccess(res, file) {
				if (res.Code == 0) {
					file.url = webapi.base_api_url + res.Data;
					file.name = res.Data;
					let itemLen = this.defaultList.length;
					this.$set(this.defaultList, itemLen, file);
					this.uploadList = this.defaultList
					this.StationPicturesArray.push(file.name)
					this.PictureDelCache.push(file.name)
				}
				//file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar';
				//file.name = '7eb99afb9d5f317c912f08b5212fd69a';
			},
			handleFormatError(file) {
				this.$Notice.warning({
					title: this.$t('Common.FormatError'),
					desc: this.$t('Common.SelectJpgOrPng')
				});
			},
			handleMaxSize(file) {
				this.$Notice.warning({
					title: this.$t('Common.ImageTooLarge'),
					desc: this.$t('Common.File') + file.name + ' '+this.$t('Common.SelectSmallerImg')
				});
			},
			handleBeforeUpload() {
				const check = this.uploadList.length < 5;
				if (!check) {
					this.$Notice.warning({
						title: 'Up to five pictures can be uploaded.'
					});
				}
				return check;
			},
			OperatorNameChange: function(a) {
				console.log(a)
				this.StationForm.OperatorId = a;
			}
		},
		mounted() {
			this.upHeader.Authorization = "Bearer " + encodeURIComponent(localStorage.AccessToken);
		},
		computed: {
		
			...mapState({
				StationList: 'Stations',
				RoleList: 'roleList',
				OperatortypeList: 'typeList'
			})
		}
	}
</script>

<style>

.battery-info-container {
  font-family: Arial, sans-serif;
  max-width: 900px;
  margin: 0 auto;
  padding:0px 5px;
  background-color: #f5f5f5;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.basic-info {
  background-color: #fff;
  padding: 5px;
  border-radius: 5px;
  margin-bottom: 10px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
}

.data-table {
  width: 100%;
  margin-bottom: 10px;
}

.data-table table {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  border-radius: 5px;
  overflow: hidden;
}

.data-table td {
  padding: 5px 5px;
  border: 1px solid #ddd;
}

.data-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.gps-history, .device-location {
  background-color: #fff;
  padding: 5px;
  border-radius: 5px;
}

.history-list {
  margin-top: 10px;
}

.history-item {
  display: flex;
  align-items: center;
  padding: 3px 0;
  border-bottom: 1px solid #eee;
}

.history-item .index {
  width: 30px;
  font-weight: bold;
}

.history-item .time {
  width: 200px;
}

.device-location p {
  margin: 5px 0;
  padding-left: 20px;
}

h3 {
  color: #333;
  border-bottom: 1px solid #eee;
  
}

</style>
